import { SwapVerticalBoldIcon } from './SwapVerticalBoldIcon';

/**
 * author: Google
 * id 0903A829-EB64-4B39-B066-FECF7908DA8A
 * name swap-vertical-bold
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/swap-vertical-bold.svg
 * tags
 * - Arrow 
 */
export const ImportExportBoldIcon = SwapVerticalBoldIcon;
export default ImportExportBoldIcon